module.exports = __webpack_public_path__ + "static/img/christopher-gower-_aXa21cf7rY-unsplash_thumb.3937bec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/christopher-gower-_aXa21cf7rY-unsplash_thumb.png
// module id = sf19
// module chunks = 4